export const dashboardStats = {
  totalArvores: 12486,
  arvoresPorEstadoFitossanitario: {
    bom: 8234,
    regular: 2856,
    ruim: 893,
    critico: 347,
    morta: 156,
  },
  arvoresPorRisco: {
    baixo: 7134,
    medio: 3845,
    alto: 1420,
    critico: 87,
  },
  especiesMaisFrequentes: [
    { nome: "Tipuana tipu", comum: "Tipuana", quantidade: 2145, percentual: 17.2 },
    { nome: "Ligustrum lucidum", comum: "Ligustro", quantidade: 1853, percentual: 14.8 },
    { nome: "Ficus benjamina", comum: "Ficus", quantidade: 1523, percentual: 12.2 },
    { nome: "Caesalpinia peltophoroides", comum: "Sibipiruna", quantidade: 1342, percentual: 10.7 },
    { nome: "Tabebuia roseoalba", comum: "Ipê-branco", quantidade: 987, percentual: 7.9 },
  ],
  projetosAtivos: 18,
  projetosTotal: 31,
  vistoriasPendentes: 342,
  vistoriasTotal: 2156,
  arvoresRiscoCritico: 87,
  arvoresComManejo: 516,
  areasVerdes: 64,
  ucsCadastradas: 9,
  co2eEstimado: 4280,
  especiesIdentificadas: 187,
};

export const projetosRecentes = [
  {
    id: "PRJ-2026-001",
    nome: "Inventário Arbóreo - Parque Ibirapuera",
    municipio: "São Paulo",
    status: "ativo",
    totalArvores: 3847,
    vistoriadas: 3201,
    progresso: 83,
    responsavel: "Secretaria do Verde e Meio Ambiente",
    inicio: "2026-01-15",
  },
  {
    id: "PRJ-2026-002",
    nome: "CTA Urbano - Centro Histórico",
    municipio: "Curitiba",
    status: "ativo",
    totalArvores: 2156,
    vistoriadas: 1850,
    progresso: 86,
    responsavel: "IPPUC - Instituto de Pesquisa e Planejamento",
    inicio: "2026-02-03",
  },
  {
    id: "PRJ-2026-003",
    nome: "Levantamento Arbóreo - Orla da Lagoa",
    municipio: "Florianópolis",
    status: "ativo",
    totalArvores: 1567,
    vistoriadas: 890,
    progresso: 57,
    responsavel: "FLORAM - Fundação Municipal do Meio Ambiente",
    inicio: "2026-03-10",
  },
  {
    id: "PRJ-2026-004",
    nome: "CTA - Expansão Urbana Norte",
    municipio: "Goiânia",
    status: "ativo",
    totalArvores: 1250,
    vistoriadas: 623,
    progresso: 50,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    inicio: "2026-04-05",
  },
  {
    id: "PRJ-2025-018",
    nome: "Inventário - Campus Universitário",
    municipio: "Campinas",
    status: "concluido",
    totalArvores: 2341,
    vistoriadas: 2341,
    progresso: 100,
    responsavel: "UNICAMP - Coordenadoria de Meio Ambiente",
    inicio: "2025-09-01",
  },
];

export const vistoriasRecentes = [
  {
    id: "VST-2026-0847",
    arvoreId: "CTA-2024-15234",
    codigoCTA: "CTA-2024-15234",
    especie: "Tipuana tipu",
    localizacao: "Av. Paulista, 1578 - Bela Vista, São Paulo/SP",
    inspetor: "Carlos Mendes",
    data: "2026-06-28",
    status: "concluida",
    risco: "baixo",
    fitossanitario: "bom",
    observacoes: "Copa com bom desenvolvimento. Sem sinais de pragas ou doenças. Sistema radicular estável.",
  },
  {
    id: "VST-2026-0846",
    arvoreId: "CTA-2024-08921",
    codigoCTA: "CTA-2024-08921",
    especie: "Ficus benjamina",
    localizacao: "Rua Augusta, 2450 - Consolação, São Paulo/SP",
    inspetor: "Ana Oliveira",
    data: "2026-06-27",
    status: "concluida",
    risco: "alto",
    fitossanitario: "regular",
    observacoes: "Raízes expostas causando danos à calçada. Galhos secos na porção superior. Recomendada poda de redução.",
  },
  {
    id: "VST-2026-0845",
    arvoreId: "CTA-2024-06712",
    codigoCTA: "CTA-2024-06712",
    especie: "Caesalpinia peltophoroides",
    localizacao: "Rua da Consolação, 3200 - Cerqueira César, São Paulo/SP",
    inspetor: "Rafael Torres",
    data: "2026-06-26",
    status: "concluida",
    risco: "medio",
    fitossanitario: "bom",
    observacoes: "Interferência com fiação elétrica no lado direito da copa. Necessário poda direcionada.",
  },
  {
    id: "VST-2026-0844",
    arvoreId: "CTA-2024-04589",
    codigoCTA: "CTA-2024-04589",
    especie: "Ligustrum lucidum",
    localizacao: "Rua XV de Novembro, 450 - Centro, Curitiba/PR",
    inspetor: "Juliana Costa",
    data: "2026-06-25",
    status: "pendente",
    risco: "medio",
    fitossanitario: "regular",
    observacoes: "Aguardando confirmação de vistoria. Relato de cidadão sobre galho com risco de queda.",
  },
  {
    id: "VST-2026-0843",
    arvoreId: "CTA-2024-03156",
    codigoCTA: "CTA-2024-03156",
    especie: "Tabebuia roseoalba",
    localizacao: "Rua Marechal Deodoro, 890 - Centro, Curitiba/PR",
    inspetor: "Marcos Vinicius",
    data: "2026-06-24",
    status: "concluida",
    risco: "baixo",
    fitossanitario: "bom",
    observacoes: "Ipê-branco em excelente estado. Floração abundante. Sem interferências. DAP: 45cm.",
  },
  {
    id: "VST-2026-0842",
    arvoreId: "CTA-2024-02341",
    codigoCTA: "CTA-2024-02341",
    especie: "Schinus molle",
    localizacao: "Av. Beira-Mar Norte, 1200 - Centro, Florianópolis/SC",
    inspetor: "Pedro Alves",
    data: "2026-06-23",
    status: "pendente",
    risco: "alto",
    fitossanitario: "ruim",
    observacoes: "Tronco com cavidade extensa. Inclinação > 15°. Risco de queda para via pública. Vistoria emergencial agendada.",
  },
  {
    id: "VST-2026-0841",
    arvoreId: "CTA-2024-01289",
    codigoCTA: "CTA-2024-01289",
    especie: "Delonix regia",
    localizacao: "Praça Santos Andrade, s/n - Centro, Curitiba/PR",
    inspetor: "Juliana Costa",
    data: "2026-06-22",
    status: "concluida",
    risco: "baixo",
    fitossanitario: "bom",
    observacoes: "Flamboyant saudável. Copa ampla com boa cobertura. Recomendada poda de manutenção leve.",
  },
];

export const manejoRecomendado = [
  { tipo: "Poda de Manutenção", quantidade: 234, cor: "bg-primary-100 text-primary-700" },
  { tipo: "Poda de Redução", quantidade: 145, cor: "bg-accent-100 text-accent-700" },
  { tipo: "Remoção", quantidade: 87, cor: "bg-danger-100 text-danger-700" },
  { tipo: "Tratamento Fitossanitário", quantidade: 98, cor: "bg-warning-100 text-warning-700" },
  { tipo: "Plantio Compensatório", quantidade: 52, cor: "bg-caution-100 text-caution-700" },
];

export const alertasPrioritarios = [
  {
    id: "ALT-001",
    titulo: "Árvores com risco crítico próximas a escolas",
    descricao: "12 árvores com risco crítico a menos de 200m de instituições de ensino. Necessária ação imediata.",
    nivel: "critico",
    quantidade: 12,
    icone: "ri-alert-line",
  },
  {
    id: "ALT-002",
    titulo: "Vistorias vencidas há mais de 30 dias",
    descricao: "47 árvores com última vistoria superior a 365 dias. Prazo normativo excedido.",
    nivel: "alto",
    quantidade: 47,
    icone: "ri-timer-line",
  },
  {
    id: "ALT-003",
    titulo: "Manejos emergenciais pendentes",
    descricao: "23 manejos classificados como emergenciais aguardando execução há mais de 15 dias.",
    nivel: "alto",
    quantidade: 23,
    icone: "ri-tools-line",
  },
  {
    id: "ALT-004",
    titulo: "Compensações ambientais sem monitoramento",
    descricao: "8 projetos de compensação sem registro de monitoramento nos últimos 12 meses.",
    nivel: "medio",
    quantidade: 8,
    icone: "ri-scales-line",
  },
  {
    id: "ALT-005",
    titulo: "UCs sem atualização recente",
    descricao: "5 Unidades de Conservação com cadastro sem atualização há mais de 18 meses.",
    nivel: "medio",
    quantidade: 5,
    icone: "ri-shield-star-line",
  },
];

export const inteligenciaUrbana = [
  {
    id: "INS-001",
    titulo: "Bairro com maior concentração de risco",
    valor: "Consolação, São Paulo/SP",
    descricao: "28% das árvores do bairro apresentam risco alto ou crítico. Concentração 3,2× acima da média municipal.",
    icone: "ri-map-pin-line",
  },
  {
    id: "INS-002",
    titulo: "Espécie mais frequente",
    valor: "Tipuana tipu (Tipuana)",
    descricao: "17,2% do total de árvores cadastradas. Presente em 78% dos projetos ativos. Boa adaptabilidade urbana.",
    icone: "ri-leaf-line",
  },
  {
    id: "INS-003",
    titulo: "Área com maior déficit arbóreo",
    valor: "Zona Leste - São Paulo/SP",
    descricao: "Índice de 0,18 árvores/habitante — 3,5× abaixo do recomendado pela OMS (0,65 árvores/habitante).",
    icone: "ri-bar-chart-line",
  },
  {
    id: "INS-004",
    titulo: "Projeto com maior avanço no mês",
    valor: "CTA Urbano - Centro Histórico (Curitiba/PR)",
    descricao: "306 novas árvores cadastradas nos últimos 30 dias. Progresso de 86% com previsão de conclusão em ago/2026.",
    icone: "ri-arrow-up-line",
  },
  {
    id: "INS-005",
    titulo: "Estimativa preliminar de carbono",
    valor: "4.280 t CO₂e (sequestro anual)",
    descricao: "Baseado em modelos alométricos preliminares. Margem de erro estimada: ±18%. Necessária calibração com inventário florestal.",
    icone: "ri-cloud-line",
  },
];

export const mapaOperacional = {
  pontos: [
    { lat: -23.5505, lng: -46.6333, tipo: "saudavel", label: "Tipuana", codigo: "CTA-15234" },
    { lat: -23.5610, lng: -46.6410, tipo: "alto", label: "Ficus", codigo: "CTA-08921" },
    { lat: -23.5550, lng: -46.6280, tipo: "medio", label: "Sibipiruna", codigo: "CTA-06712" },
    { lat: -23.5480, lng: -46.6370, tipo: "medio", label: "Ligustro", codigo: "CTA-04589" },
    { lat: -23.5420, lng: -46.6310, tipo: "saudavel", label: "Ipê-branco", codigo: "CTA-03156" },
    { lat: -23.5580, lng: -46.6400, tipo: "critico", label: "Munguba", codigo: "CTA-03456" },
    { lat: -23.5520, lng: -46.6360, tipo: "saudavel", label: "Ipê-amarelo", codigo: "CTA-07890" },
    { lat: -23.5450, lng: -46.6290, tipo: "alto", label: "Aroeira", codigo: "CTA-02341" },
    { lat: -23.5470, lng: -46.6430, tipo: "saudavel", label: "Jacarandá", codigo: "CTA-05678" },
    { lat: -23.5530, lng: -46.6340, tipo: "areaVerde", label: "Praça", codigo: "AV-0042" },
    { lat: -23.5490, lng: -46.6390, tipo: "areaVerde", label: "Parque", codigo: "UC-0012" },
    { lat: -23.5570, lng: -46.6320, tipo: "saudavel", label: "Flamboyant", codigo: "CTA-01289" },
  ],
};

export const dadosMensais = [
  { mes: "Jan", arvores: 234, vistorias: 187 },
  { mes: "Fev", arvores: 289, vistorias: 210 },
  { mes: "Mar", arvores: 345, vistorias: 256 },
  { mes: "Abr", arvores: 412, vistorias: 298 },
  { mes: "Mai", arvores: 378, vistorias: 312 },
  { mes: "Jun", arvores: 421, vistorias: 345 },
];